import { ITEM_DO_RODAPE_DA_GAVETA } from '@/components/layout/itemDaGaveta';
import { Link, useLocation } from 'react-router-dom';
import { BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { sessaoLiberada } from '@/features/auth/sessaoLiberada';
import { foraDaProva } from '@/features/relatos/podeRelatar';
import { useContagemDeNaoLidas } from './api';

/**
 * O SINO DA CENTRAL DE NOTIFICAÇÕES (19/10/2026), com o número de não lidas. Montado nos mesmos lugares do "Relatar
 * algo" — a barra do topo, a gaveta e o rodapé das três barras laterais — e, no celular, também no topo, ao lado do menu.
 * Some na página da prova (`foraDaProva`, a mesma regra do relato).
 *
 * `variante="icone"` é o sino com a bolinha; `"item"` é a linha de menu ("Notificações · 3"), para as gavetas.
 */
export function SinoDeNotificacoes({ variante = 'icone', className, aoNavegar }: { variante?: 'icone' | 'item'; className?: string; aoNavegar?: () => void }) {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();
  const visivel = isAuthenticated && sessaoLiberada(user) && foraDaProva(pathname);
  const { data: naoLidas = 0 } = useContagemDeNaoLidas(visivel, pathname);
  if (!visivel) return null;
  const rotulo = naoLidas > 0 ? `Notificações: ${naoLidas} não ${naoLidas === 1 ? 'lida' : 'lidas'}` : 'Notificações';
  const numero = naoLidas > 99 ? '99+' : String(naoLidas);

  if (variante === 'item') {
    return (
      <Link to="/notificacoes" onClick={aoNavegar} data-testid="sino-item" aria-label={rotulo}
        className={className ?? ITEM_DO_RODAPE_DA_GAVETA}>
        <BellIcon className="h-5 w-5 flex-shrink-0" aria-hidden />
        <span className="flex-1">Notificações</span>
        {naoLidas > 0 && <span className="rounded-full bg-red-600 px-2 text-xs font-semibold leading-5 text-white">{numero}</span>}
      </Link>
    );
  }
  return (
    <Link to="/notificacoes" onClick={aoNavegar} data-testid="sino" aria-label={rotulo} title={rotulo}
      className={className ?? 'relative inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md text-gray-600 hover:bg-gray-100 hover:text-marca-600'}>
      <BellIcon className="h-6 w-6" aria-hidden />
      {naoLidas > 0 && (
        <span data-testid="sino-contador" className="absolute right-1 top-1 min-w-[1.1rem] rounded-full bg-red-600 px-1 text-center text-[0.65rem] font-semibold leading-[1.1rem] text-white">
          {numero}
        </span>
      )}
    </Link>
  );
}
